import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  private api = inject(ApiService);

  list() { return this.api.get('/password_reset'); }
  getFile(fname: string) { return this.api.get(`/password_reset/file/${fname}`); }
  add(json: any) { return this.api.post('/password_reset', json); }
  allocation(json: any) { return this.api.post('/password_reset/allocation', json); }
}
